import type React from "react";
import { Box, Typography, Avatar, Paper, Grid, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

interface DetailsCardProps {
  title: string;
  avatar?: string;
  details: Record<string, string | number>;
  hideAvatarName?: boolean;
  entityName?: string;
}

const DetailsCard: React.FC<DetailsCardProps> = ({
  title,
  avatar,
  details,
  hideAvatarName = false,
  entityName,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Paper sx={{ p: 2, height: "100%", boxShadow: 0 }}>
      <Typography variant="h6" sx={{ fontSize: 16 }}>
        {title}
      </Typography>

      {avatar && !hideAvatarName && (
        <Box mt={2} display="flex" alignItems="center">
          <Avatar src={avatar} sx={{ width: 56, height: 56, mr: 2 }} />
          <Typography variant="h6" fontWeight="bold">
            {entityName || title}
          </Typography>
        </Box>
      )}

      <Grid container spacing={1} mt={hideAvatarName ? 1 : 1}>
        {Object.entries(details).map(([label, value]) => (
          <Grid size={{ xs: 6 }} key={label}>
            <Typography variant="caption" sx={{ color: colors.primary[300] }}>
              {label
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase())}
            </Typography>
            <Typography>{String(value)}</Typography>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default DetailsCard;
